import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {forkJoin} from 'rxjs';
import {tap} from 'rxjs/operators';
import { merge } from 'es-toolkit';
import {environment} from '../../environments/environment';
import {BaseService} from '../../../../shared/src/lib/services/base.service';

// import {SubmissionService} from './submission.service';

@Injectable({
  providedIn: 'root'
})
export class BeachesService extends BaseService {
  public item: any = {};
  public meta: any = {};

  // public beachService = environment.beachService;

  monitoringActivityService: BaseService;
  advisoryService: BaseService;
  advisoryAggregateService: BaseService;
  submissionsService: BaseService;
  characteristicsService: BaseService;
  measuresService: BaseService;
  unitsService: BaseService;
  beachService: BaseService;
  resultsService: BaseService;

  constructor(http: HttpClient) {
    super(`${environment.baseUrl}/beaches/monitoringlocation`, http);
    this.monitoringActivityService = new BaseService(`${environment.baseUrl}/beaches/monitoringactivity`, http);
    this.advisoryService = new BaseService(`${environment.baseUrl}/beaches/advisoryactivity`, http);
    this.advisoryAggregateService = new BaseService(`${environment.baseUrl}/beaches/beachadvisoryaggregate`, http);
    this.submissionsService = new BaseService(`${environment.baseUrl}/beaches/submission`, http);
    this.characteristicsService = new BaseService(`${environment.baseUrl}/beaches/characteristicchoices`, http);
    this.measuresService = new BaseService(`${environment.baseUrl}/beaches/measurechoices`, http);
    this.unitsService = new BaseService(`${environment.baseUrl}/beaches/unitchoices`, http);
    this.beachService = new BaseService(`${environment.baseUrl}/beaches/beach`, http);
    this.resultsService = new BaseService(`${environment.baseUrl}/beaches/result`, http);
  }

  loadData(searchObj) {
    return forkJoin({
      monitoring_meta: this.monitoringActivityService.loadMetadata(),
      advisory_meta: this.advisoryService.loadMetadata(),
      items: this.getList<any>(searchObj)
    }).pipe(tap(responses => {
      // Restangular.all('beaches/monitoringlocation').getList(searchObj).then(function (items) {
      if (responses.items.results[0]) {
        merge(this.item, responses.items.results[0]);
      } else {
        this.item = {};
      }
      merge(this.meta, responses.items.meta);
      // TODO: figure out exactly what should be displayed
      // this.meta.display_fields = [
      //     'identifier', 'name', 'description', 'comment', 'access_type', 'access_comment',
      //     'waterbody_name_code', 'waterbody_type_code', 'extent_length_measure', 'extent_unit_of_measure',
      //     'swim_season_startdate', 'swim_season_enddate', 'swim_season_frequency_measure',
      //     'monitoring_freq_unit_of_measure', 'monitor'
      // ];
      this.meta.display_fields = ['locationid', 'type', 'collection_method', 'datum', 'horizontal_collection_method',
        'submit_advisories'];
      this.meta.type = 'beaches/monitoringlocation';
      this.meta.subItems = ['monitoring_activity', 'advisory_activity', 'attachments'];
      this.meta.fields.attachments = {type: 'beaches/attachments'};
//                this.meta.autocomplete = {
//                    "field": 'name',
//                    "url": "/api/water_sampling/monitoringlocation/?search=",
//                    "foreign_key": "site"
//                };
      this.meta.urlPath = 'monitoringlocation';
      this.meta.featureService = environment.beachService;
      // Restangular.one('water_sampling/monitoringactivity', 'metadata').get().then(function (activity_meta) {
      this.meta.fields.monitoring_activity = responses.monitoring_meta;
      this.meta.fields.monitoring_activity.display_fields = [
        'activityid', 'type', 'media', 'sample_collection_datetime', 'sample_collection_equipment', 'sample_collection_methodid',
        'sample_collection_method_context', 'sample_collection_name',
        'wind', 'windDirection', 'tidalStage', 'waterSurface', 'waterColor', 'turbid',
        'smell', 'weather24Hour', 'weatherNow', 'other', 'averageTemp', 'rainfallWeekly', 'averageHumidity'
      ];
      this.meta.fields.monitoring_activity.type = 'beaches/monitoringactivity';
      this.meta.fields.monitoring_activity.foreign_key_field = 'monitoring_location';
      this.meta.fields.monitoring_activity.subItems = ['result'];
      // // this.meta.fields.monitoring_activity.verbose_name = ;
      // // this.meta.fields.monitoring_activity.verbose_name_plural = 'Monitoring Activities';
      this.meta.fields.monitoring_activity.result = {
        //   // fields: responses.monitoring_meta.fields.result.child.children,
        verbose_name_plural: 'Results',
        verbose_name: 'Result',
        display_fields: [
          'characteristicname', 'status', 'valuetype', 'measure', 'units',
              'geometric_mean',
              'stv',
          'analytical_method_id', 'analytical_method_context', 'analytical_method_name',
          // 'analytical_method_text',
          'lab_name'
        ],
        foreign_key_field: 'monitoring_activity',
        type: 'beaches/result',
        deleteText: 'Are you sure you want to remove this result from this activity?',
        fields: {
          // todo: logic in here is causing inconsistent UI b/c of toggling field types
          characteristicname: {
            get_choices: (search) => {
              if (typeof search === 'object') {
                search = search.characteristicname;
              }
              return new Promise(resolve => {
                this.characteristicsService.getList<any>({search}).pipe(tap(response => {
                  if (response.results.length > 0) {
                    this.meta.fields.monitoring_activity.result.fields.characteristicname.type = 'choice';
                  } else {
                    this.meta.fields.monitoring_activity.result.fields.characteristicname.type = 'string';
                  }
                  const choices = response.results.map(item => {
                    item.display_name = item.label;
                    return item;
                  });
                  resolve(choices);
                }));
              });
            },
            select_choice: (selected, item, modelMeta) => {
              const promises = [];
              item.valuetype = selected.default_value_type;
              item.analytical_method_id = selected.default_analytical_method_id;
              item.analytical_method_context = selected.default_analytical_method_context;
              item.analytical_method_name = selected.default_analytical_method_name;
              item.analytical_method_text = selected.default_analytical_method_text;

              promises.push(this.measuresService.getList<any>({characteristic__id: selected.id}).pipe(tap(response => {
                if (response.results.length > 0) {
                  modelMeta.fields.measure.type = 'choice';
                  modelMeta.fields.units.type = 'string';
                  delete modelMeta.fields.units.choices;
                  delete item.units;
                  modelMeta.fields.measure.choices = response.results.map(i => {
                    return {display_name: i.label, value: i.value};
                  });
                  const found = modelMeta.fields.measure.choices.find(choice => choice.value === item.measure);
                  if (!found) {
                    delete item.measure;
                  }
                  if (response.results.length === 1) {
                    item.measure = response[0].value;
                  }
                }
              })));

              promises.push(this.unitsService.getList<any>({characteristic__id: selected.id}).pipe(tap(response => {
                if (response.results.length > 0) {
                  modelMeta.fields.units.type = 'choice';
                  modelMeta.fields.measure.type = 'float';
                  delete modelMeta.fields.measure.choices;
                  delete item.measure;
                  modelMeta.fields.units.choices = response.results.map(i => {
                    return {display_name: i.label, value: i.value};
                  });
                  const found = modelMeta.fields.units.choices.find(choice => choice.value === item.units);
                  if (!found) {
                    delete item.units;
                  }
                  if (response.results.length === 1) {
                    item.units = response[0].value;
                  }
                }
              })));
              return forkJoin(promises);
            },
            clear_choice: (modelMeta, item) => {
              modelMeta.fields.units.type = 'string';
              delete modelMeta.fields.units.choices;
              modelMeta.fields.measure.type = 'string';
              delete modelMeta.fields.measure.choices;
            }
          },
          measure: {
            get_choices: (search) => {
              if (typeof search === 'object') {
                search = search.measure;
              }
              return new Promise(resolve => {
                this.measuresService.getList<any>({search}).pipe(tap(response => {
                  if (response.results.length > 0) {
                    this.meta.fields.monitoring_activity.result.fields.measure.type = 'choice';
                  } else {
                    this.meta.fields.monitoring_activity.result.fields.measure.type = 'float';
                  }
                  const choices = response.results.map(item => {
                    item.display_name = item.label;
                    return item;
                  });
                  resolve(choices);
                }));
              });
            },
          },
          units: {
            get_choices: (search) => {
              if (typeof search === 'object') {
                search = search.units;
              }
              return new Promise(resolve => {
                this.unitsService.getList<any>({search}).pipe(tap(response => {
                  if (response.results.length > 0) {
                    this.meta.fields.monitoring_activity.result.fields.units.type = 'choice';
                    this.meta.fields.monitoring_activity.result.fields.measure.type = 'float';
                    const choices = response.results.map(i => {
                      return {display_name: i.label, value: i.value};
                    });
                    resolve(choices);
                  }
                }));
              });
            }
          }
        }
      };


      // results

      // precision criteria
      // this.meta.fields.monitoring_activity.precisioncriteria = {
      //   // fields: responses.monitoring_meta.fields.precisioncriteria.child.children,
      //   verbose_name: 'Precision Criteria',
      //   verbose_name_plural: 'Precision Criteria',
      //   display_fields: ['sample_datetime', 'lab_id', 'duplicate_lab_id', 'result'],
      //   foreign_key_field: 'monitoring_activity',
      //   type: 'beaches/precisioncriteria',
      //   deleteText: 'Are you sure you want to remove this precision criteria from this activity?'
      // };
      // });
      // Restangular.one('beaches/advisoryactivity', 'metadata').get().then(function (advisory_meta) {

      this.meta.fields.advisory_activity = responses.advisory_meta;
      this.meta.fields.advisory_activity.display_fields = [
        'type_code', 'actual_startdate', 'actual_stopdate', 'activity_description',
        'activity_comment', 'activity_reason', 'activity_reason_description', 'activity_source',
        'activity_source_description', 'activity_indicator', 'activity_indicator_description'
      ];
      this.meta.fields.advisory_activity.type = 'beaches/advisoryactivity';
      this.meta.fields.advisory_activity.foreign_key_field = 'monitoring_location';
      // this.meta.fields.advisory_activity.verbose_name = 'Advisory Activity';
      // this.meta.fields.advisory_activity.verbose_name_plural = 'Advisory Activities';
      // });

    }));
  }


  public loadMeta() {
    this.loadMetadata().pipe(tap(meta => {
      this.meta = meta;
    }));
  }

  public loadSubmissions(searchParams) {
    return this.submissionsService.getList(searchParams);
  }

  // loadSubmission(id) {
  //
  //   return forkJoin({
  //     locations: this.getList({search: id, page_size: 1000, ordering: 'id'}),
  //     activites: this.advisoryService.getList({search: id, ordering: 'id,-sample_collection_datetime'})
  //   });
  // return this.getList({
  //             search: id,
  //             page_size: 1000,
  //             ordering: 'id'
  //         }).pipe(tap(locations  => {
  // response.locations = locations.results;
  // serviceObj.currentSubmission.locations.meta.display_fields = ['name', 'id', 'type', 'collection_method', 'datum',
  //     'horizontal_collection_method'];
  // serviceObj.currentSubmission.locations.meta.type = 'beaches/monitoringlocation';
  // serviceObj.currentSubmission.locations.meta.verbose_name = 'Monitoring Location';
  // serviceObj.currentSubmission.locations.meta.verbose_name_plural = 'Monitoring Locations';
  // serviceObj.currentSubmission.locations.meta.autocomplete = {
  //     "url": "/api/beaches/monitoringlocation/?search=",
  //     "foreign_key": "site",
  //     "field": "name"
  // };
  // }),

  // var activityPromise = Restangular.all('beaches/monitoringactivity').getList({
  //     search: id,
  //     ordering: 'id,-sample_collection_datetime'
  // }).then(function (activities) {
  //     serviceObj.currentSubmission.activities = activities;
  //     // adding search params enableds infinite scroll on submission list directive.
  //     serviceObj.currentSubmission.activities.meta.searchParams = {search: id, ordering: 'id,-sample_collection_datetime'};
  //     serviceObj.currentSubmission.activities.meta.display_fields = [
  //         'id', 'type', 'media', 'sample_collection_datetime', 'sample_collection_equipment', 'sample_collection_methodid',
  //         'sample_collection_method_context', 'sample_collection_name', ''
  //     ];
  //     serviceObj.currentSubmission.activities.meta.type = 'beaches/monitoringactivity';
  //     serviceObj.currentSubmission.activities.meta.subItems = ['result'];
  //     // Beaches.meta.fields.monitoring_activity.verbose_name = 'Monitoring Activity';
  //     // Beaches.meta.fields.monitoring_activity.verbose_name_plural = 'Monitoring Activities';
  //     serviceObj.currentSubmission.activities.meta.autocomplete = {
  //         "url": "/api/beaches/monitoringactivity/?search=",
  //         "foreign_key": "monitoring_location",
  //         "field": "id"
  //     };
  //
  //     //results
  //     serviceObj.currentSubmission.activities.meta.fields.result = {
  //         fields: activities.meta.fields,
  //         verbose_name_plural: 'Results',
  //         verbose_name: 'Result',
  //         display_fields: ['characteristicname', 'status', 'valuetype', 'measure', 'units', 'geometric_mean'],
  //         foreign_key_field: 'monitoring_activity',
  //         deleteText: 'Are you sure you want to remove this result from this activity?'
  //     };
  // });

  // var beachMeta;
  // var beachPromise = Restangular.all('beaches/beach').getList({search: id, page_size: 1000})
  //     .then(function (beaches) {
  //         serviceObj.currentSubmission.beaches = beaches;
  //         beachMeta = beaches.meta;
  //         beachMeta.display_fields = ['name', 'identifier', 'description', 'comment', 'state_code', 'fips_code',
  //             'access_type', 'access_comment', 'waterbody_name_code', 'waterbody_type_code', 'extent_length_measure',
  //             'extent_unit_of_measure', 'effective_year', 'swim_season_startdate', 'swim_season_enddate', 'swim_season_frequency_measure',
  //             'monitoring_freq_unit_of_measure', 'monitored_irregularly', 'monitored_irregularly_comment', 'tier_ranking',
  //             'beach_act_indicator', 'pollution_status', 'dormant_indicator', 'website', 'reporting_frequency_measure',
  //             'reporting_freq_unit_of_measure'];
  //
  //         beachMeta.type = 'beaches/beach';
  //         beachMeta.autocomplete = {
  //             "url": "/api/beaches/beach/?search=",
  //             "foreign_key": "monitoring_location",
  //             "field": "name"
  //         };
  //         beachMeta.subItems = ['beach_advisory', 'pollution', 'procedure'];
  //         Restangular.all('beaches/beachadvisoryaggregate').getList({
  //             search: id,
  //             page_size: 9999
  //         }).then(function (advisories) {
  //             angular.forEach(serviceObj.currentSubmission.beaches, function (beach, i) {
  //                 beach.beach_advisory = $filter('filter')(advisories, {beach: beach.globalid});
  //             });
  //             // serviceObj.currentSubmission.beaches.beach_advisory = advisories;
  //             beachMeta.fields.beach_advisory = advisories.meta;
  //             beachMeta.fields.beach_advisory.display_fields = ['type_code',
  //                 'name', 'actual_startdate', 'actual_stopdate', 'activity_description',
  //                 'activity_comment', 'extent_start_measure', 'extent_length_measure', 'extent_unit_of_measure',
  //                 'activity_reason', 'activity_source', 'activity_indicator'];
  //             beachMeta.fields.beach_advisory.foreign_key_field = 'beach';
  //         });
  //
  //         Restangular.all('beaches/procedure').getList({
  //             search: id,
  //             page_size: 9999
  //         }).then(function (procedures) {
  //             angular.forEach(serviceObj.currentSubmission.beaches, function (beach, i) {
  //                 beach.procedure = $filter('filter')(procedures, {beach: beach.globalid});
  //             });
  //             beachMeta.fields.procedure = procedures.meta;
  //             beachMeta.fields.procedure.display_fields = ['type_code', 'description'];
  //             beachMeta.fields.procedure.foreign_key_field = 'beach';
  //         });
  //
  //         Restangular.all('beaches/pollution').getList({
  //             search: id,
  //             page_size: 9999
  //         }).then(function (pollution) {
  //             angular.forEach(serviceObj.currentSubmission.beaches, function (beach, i) {
  //                 beach.pollution = $filter('filter')(pollution, {beach: beach.globalid});
  //             });
  //             beachMeta.fields.pollution = pollution.meta;
  //             beachMeta.fields.pollution.display_fields = ['source_code', 'source_description'];
  //             beachMeta.fields.pollution.foreign_key_field = 'beach';
  //         });
  //     });
  //
  // beachPromise.finally(function () {
  //     serviceObj.currentSubmission.beaches.meta = beachMeta;
  // });
  // $q.all([locationPromise, activityPromise, beachPromise]).then(function () {
  //     serviceObj.loadingContent = false;
  // });

  // }
  // createSubmission: function (compType) {
  //     serviceObj.currentSubmission.saving = true;
  //     serviceObj.currentSubmission.compilation_type = compType;
  //     serviceObj.currentSubmission = Restangular.restangularizeElement(undefined, serviceObj.currentSubmission, 'beaches/submission');
  //     serviceObj.currentSubmission.save().then(function (response) {
  //         serviceObj.currentSubmission = response;
  //         serviceObj.loadSubmission(response.globalid);
  //     }).finally(function () {
  //         serviceObj.saving = false;
  //     });
  // },
  // submitSubmission: function () {
  //     if (serviceObj.user.email !== undefined && serviceObj.user.password !== undefined) {
  //         serviceObj.submitting = true;
  //         Restangular.all('user/submit_cdx_creds').post({
  //             'username': serviceObj.user.email,
  //             'password': serviceObj.user.password
  //         }).then(function () {
  //             serviceObj.currentSubmission.post("submit").then(function (response) {
  //                 serviceObj.currentSubmission.status = response.status;
  //                 serviceObj.currentSubmission.statusDescription = response.statusDescription;
  //                 serviceObj.currentSubmission.date = response.date;
  //             }).finally(function () {
  //                 serviceObj.submitting = false;
  //             });
  //         }).catch(function () {
  //             serviceObj.submitting = false;
  //         });
  //     } else {
  //         toastr.error('Please provide CDX credentials.')
  //     }
  // },
  // updateSubmission: function () {
  //     serviceObj.submitting = true;
  //     Restangular.one('user').post("submit_cdx_creds", {
  //         'username': serviceObj.user.email,
  //         'password': serviceObj.user.password
  //     }).then(function () {
  //         serviceObj.currentSubmission.post("update_status").then(function (response) {
  //             serviceObj.currentSubmission.status = response.status;
  //             serviceObj.currentSubmission.statusDescription = response.statusDescription;
  //             serviceObj.currentSubmission.date = response.date;
  //         }).finally(function () {
  //             serviceObj.submitting = false;
  //         })
  //     }).catch(function () {
  //         serviceObj.submitting = false;
  //     });
  // },
  // getSubmissionReport: function () {
  //     Restangular.one('user').post("submit_cdx_creds", {
  //         'username': serviceObj.user.email,
  //         'password': serviceObj.user.password
  //     }).then(function () {
  //         $window.location = '/api/beaches/submission/' + serviceObj.currentSubmission.globalid + '/get_report/';
  //     });
  // },
  // getUser: function () {
  //     return Restangular.one('user').get().then(function (user) {
  //         angular.extend(serviceObj.user, user);
  //     });
  // }

}
